export const ModalWidth600 = 600;
export const ModalWidth880 = 880;
